@for (provider of providers(); track provider) {
  <button
    type="button"
    class="relative flex h-10.25 w-full items-center justify-center rounded-btn px-3.5 text-sm font-medium tracking-tight text-zinc-200 inset-ring inset-ring-zinc-700 transition-colors duration-150 hover:bg-zinc-900 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50 disabled:cursor-not-allowed disabled:opacity-60 motion-reduce:transition-none"
    [disabled]="busy()"
    (click)="picked.emit(provider)">
    <img
      class="absolute left-3.5 size-4"
      alt=""
      [src]="'assets/images/icons/' + provider + '.svg'" />
    @if (intent() === 'register') {
      @switch (provider) {
        @case ('google') {
          {{ 'pages.auth.oidc.signUp.google' | transloco }}
        }
        @case ('microsoft') {
          {{ 'pages.auth.oidc.signUp.microsoft' | transloco }}
        }
        @case ('github') {
          {{ 'pages.auth.oidc.signUp.github' | transloco }}
        }
        @case ('apple') {
          {{ 'pages.auth.oidc.signUp.apple' | transloco }}
        }
      }
    } @else {
      @switch (provider) {
        @case ('google') {
          {{ 'pages.auth.oidc.signIn.google' | transloco }}
        }
        @case ('microsoft') {
          {{ 'pages.auth.oidc.signIn.microsoft' | transloco }}
        }
        @case ('github') {
          {{ 'pages.auth.oidc.signIn.github' | transloco }}
        }
        @case ('apple') {
          {{ 'pages.auth.oidc.signIn.apple' | transloco }}
        }
      }
    }
  </button>
}
